import { BeddingRequest, Event, EventBeddingType, EventEntryFee, EventFee, EventStallType, StablingRequest } from "../../models"
import { getEventStallTypesByEventId } from "./EventStallType"

export interface StablingAndExtrasItem {
    value: string; //EventStallType Id
    label: string; //EventStallType name
    cost: string
    description: string
    eventStallType?: EventStallType
    eventBeddingType?: EventBeddingType
    eventBeddingTypeId?: string
    previousStablingRequest?: StablingRequest
    previousBeddingRequest?: BeddingRequest
    isRequired?: boolean
    startDateTime?: string //Formatted like YYYY-MM-DDHH:MM:SS
    eventFee?: EventFee
    previousEventEntryFee?: EventEntryFee
}

export interface StablingAndExtrasOptionsData {
    label: string
    options: StablingAndExtrasItem[] //Could have no options for the given section
}

export const getFormattedStablingOptionDataForEventStalls = async (event: Event) => {
    let stablingOptionData: StablingAndExtrasOptionsData = {
        label: "Stabling",
        options: [{ value: "0", label: "No stabling options for this event", cost: "0", description: ""}]
    };

    const currentEventStallTypes: EventStallType[] = await getEventStallTypes(event);
    const formattedData = formatStallData(currentEventStallTypes);

    stablingOptionData.options = formattedData;

    return stablingOptionData;
}

const getEventStallTypes = async (event: Event) => {
    let currentEventStallTypes: EventStallType[] = [];
    const queryResult = await getEventStallTypesByEventId(event.id);
    if (queryResult.isSuccess) {
        currentEventStallTypes = queryResult.result;
    }
    return currentEventStallTypes;
}

export const formatStallData = (currentEventStallTypes: EventStallType[]) => {
    const formattedData: StablingAndExtrasItem[] = [];
    for (let i = 0; i < currentEventStallTypes.length; i++) {
        const current = currentEventStallTypes[i];
        const formatted: StablingAndExtrasItem = {
            value: current.id,
            label: current.name || "Unknown Name",
            cost: current.pricePerStall || "Unknown Price",
            description: current.description || "",
            eventStallType: current
        };
        formattedData.push(formatted);
    }
    const sortedData = formattedData.sort((a, b) => a.label.localeCompare(b.label));
    return sortedData;
}